import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";

const ReservationBlock = ({ reservation, style, onResize, onClick }) => {
  const isCheckedIn = reservation.status === "checked_in";

  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: reservation.reservation_id.toString(),
    data: { reservation },
    disabled: isCheckedIn,
  });

  const handleResizePointerDown = (e) => {
    e.stopPropagation(); // Prevent drag start
    e.preventDefault();

    const startX = e.clientX;

    const handlePointerMove = () => {
      // Visual feedback could be added here
    };

    const handlePointerUp = (upEvent) => {
      const deltaX = upEvent.clientX - startX;
      const daysAdded = Math.round(deltaX / 100);

      if (daysAdded !== 0 && onResize) {
        const checkIn = new Date(reservation.check_in);
        const checkOut = new Date(reservation.check_out);
        const currentDuration = Math.round(
          (checkOut.getTime() - checkIn.getTime()) / (1000 * 60 * 60 * 24)
        );
        const newDuration = currentDuration + daysAdded;
        if (newDuration > 0) {
          onResize(newDuration);
        }
      }

      document.removeEventListener("pointermove", handlePointerMove);
      document.removeEventListener("pointerup", handlePointerUp);
    };

    document.addEventListener("pointermove", handlePointerMove);
    document.addEventListener("pointerup", handlePointerUp);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "checked_in":
        return "#3b82f6";
      case "checked_out":
        return "#f4bd4eff"; // Blue
      case "booked":
        return "#22c55e"; // Green
      case "payment_pending":
        return "#ef4444"; // Red
      case "maintenance":
        return "#1e1b4b"; // Navy
      default:
        return "#3b82f6";
    }
  };

  const backgroundColor = getStatusColor(reservation.status);

  console.log(reservation);

  const mergedStyle = {
    ...style,
    transform: CSS.Translate.toString(transform),
    position: "absolute",
    height: "30px", // Match row height (50px) with small gap
    top: "3px",
    backgroundColor: backgroundColor, // Use status color
    color: "white", // White text for contrast
    borderRadius: "8px", // Slightly less rounded
    padding: "0 10px", // Add padding
    fontSize: "12px",
    overflow: "visible",
    whiteSpace: "nowrap",
    cursor: isCheckedIn ? "default" : "grab",
    zIndex: transform ? 999 : 10,
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    display: "flex",
    alignItems: "center",
    border: "none",
  };

  return (
    <div
      ref={setNodeRef}
      style={mergedStyle}
      {...listeners}
      {...attributes}
      onClick={(e) => {
        // Prevent click when dragging
        if (!transform) {
          e.stopPropagation(); // Ensure click doesn't bubble to grid/row
          onClick && onClick(e);
        }
      }}
    >
      <div className="fw-bold text-truncate" style={{ flex: 1 }}>
        {reservation.guest_name}
      </div>

      {/* Status Badge (Optional - keeping if desired, or can remove) */}
      {/* <div style={{...}}>$</div> */}

      {/* Resize Handle */}
      <div
        onPointerDown={handleResizePointerDown}
        style={{
          position: "absolute",
          right: 0,
          top: 0,
          bottom: 0,
          width: "10px",
          cursor: "ew-resize",
          backgroundColor: "transparent",
        }}
      />
    </div>
  );
};

export default ReservationBlock;
